export default ({ item }) => {
  return (
    <>
      <span>{item?.reaction}</span>
    </>
  );
};
